import { useQuery } from '@tanstack/react-query'
import {
  fetchPartyDistrictStatesWithDistricts,
  partyDistrictStateKeys,
} from '@/services/partyDistrictStates'

export function usePartyDistrictStatesWithDistricts(partyId: string | undefined) {
  const query = useQuery({
    queryKey: partyDistrictStateKeys.byPartyWithDistricts(partyId!),
    queryFn: () => fetchPartyDistrictStatesWithDistricts(partyId!),
    enabled: !!partyId,
  })

  return {
    districtStates: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}
